/**
 * Consent-Abfrage fuer die "Tickets kaufen"-Buttons auf Event-Seiten.
 *
 * eb_widgets.js ist per DCCookie_eventbrite blockiert, ohne Zustimmung bindet
 * Eventbrite die Buttons nie und der Klick verpufft. DCCookie zeigt seinen
 * Hinweis nur im DCCookie_eventbriteContainer am Seitenende, den sieht beim
 * Klick niemand. Deshalb oeffnen die Buttons ohne Zustimmung ein Modal mit dem
 * Hinweis, nach der Zustimmung geht direkt der Checkout auf.
 *
 * Das Modal oeffnet cronus ueber data-modal (triggerModal). Wir importieren
 * showModal bewusst nicht, das wuerde modal.js samt Abhaengigkeiten ein
 * zweites Mal in child.js bundeln.
 */
import {hasCookieConsent, onCookieConsent} from "./cookieConsent";
import {renderCookiePlaceholder} from "./cookiePlaceholder";

const EVENTBRITE_PROVIDER_ID = 'eventbrite';
const MODAL_ID = 'eventbriteConsentModal';

/** Wird im Inline-Script aus collection_events_full.php nach createWidget gesetzt. */
function whenWidgetReady(callback) {
    if (window.dcEventbriteWidgetReady) {
        callback();
        return;
    }

    document.addEventListener('eventbriteWidgetReady', callback, {once: true});
}

export function initEventbriteConsent() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const triggers = document.querySelectorAll(`[data-modal="${MODAL_ID}"]`);

    // cronus liest data-modal erst beim Klick aus und oeffnet ohne Attribut
    // nichts - der Klick gehoert dann allein Eventbrite.
    const releaseTriggers = () => triggers.forEach(trigger => trigger.removeAttribute('data-modal'));

    if (hasCookieConsent(EVENTBRITE_PROVIDER_ID)) {
        releaseTriggers();
        return;
    }

    renderCookiePlaceholder(modal.querySelector('.modal__body'), EVENTBRITE_PROVIDER_ID);

    let pendingTrigger = null;
    triggers.forEach(trigger => trigger.addEventListener('click', () => {
        pendingTrigger = trigger;
    }));

    onCookieConsent(EVENTBRITE_PROVIDER_ID, document.body, () => {
        releaseTriggers();

        // Zustimmung ueber das Cookie-Banner: nur freischalten, nichts oeffnen.
        if (!pendingTrigger || !modal.classList.contains('open')) return;

        modal.querySelector('[data-close="modal"]')?.click();
        whenWidgetReady(() => pendingTrigger.click());
    });
}
